import { Grid, TextField, Button, MenuItem } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  baseApiURL,
  tableIcons,
  BootstrapInput,
} from "../../../Utilities/Utility";
import { tableOptionsExport } from "../../../Themes/LightTheme";
import MaterialTable from "material-table";
import SnackbarCustom from "../../../Components/Snackbar/Snackbar";
import Loading from "../../../Components/Loader/Loader";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { useSelector, useDispatch } from "react-redux";
import {
  AddDisciplineAttachmentDetails,
  DeleteD4WhyDetails,
  DeleteD4WhyNotDetails,
  GetD4WhyDetails,
  GetD4WhyNotDetails,
  GetDisciplineAttachmentDetails,
  PostD4Details,
  PostD4WhyDetails,
  postD4WhyNotDetails,
  UpdateD4,
  UpdateD4_Why,
  UpdateD4_WhyNot,
  getRCADDL,
} from "../../../Redux/APIs/api_Disciplines";
import { DeleteDisciplineAttachments } from "../../../Redux/APIs/api_Complaint";
import FormControl from "@material-ui/core/FormControl";
import { disciplineAction } from "../../../Redux/Actions/actions";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Page1 from "./discipline4page1";
import Page2 from "./discipline4page2";
import Page3 from "./discipline4page3";
import Page4 from "./discipline4page4";
import Page5 from "./discipline4page5";

export default function Discipline4(props) {
  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const dispatch = useDispatch();
  const discpline4Data = useSelector(
    (state) => state.disciplineReducer.disciplineData
  );
  const [cause1TableData, setCause1TableData] = useState([]);
  const [cause2TableData, setCause2TableData] = useState([]);
  const [attachmentData, setAttchmentData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isLoaderDraft, setIsLoaderDraft] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [reproduce, setReproduce] = useState("");
  let [inputFileAttachment, setInputFileAttachment] = useState(Date.now);
  const [open, setOpen] = useState(false);
  const [responseLengthTable1, setResponseLengthTable1] = useState(null);
  const [responseLengthTable2, setResponseLengthTable2] = useState(null);
  const [disableJustify, setdisableJustify] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = (e) => {
    setOpenValidationDialog(false);
  };
  const [openValidationDialog, setOpenValidationDialog] = useState("");
  const [dialogErrorText, setDialogErrorText] = useState("");
  const handleClickOpenDialogValidation = (text) => {
    setDialogErrorText(text);
    setOpenValidationDialog(true);
  };
  const [inputValues, setInputValues] = useState({
    HaveYouReproduced:
      props.response.length > 0 ? props?.response[0]?.haveYouReproduced : null,
    Justification:
      props.response.length > 0 ? props?.response[0]?.justification : "",
    complaintNum: props.rowData[0]?.complaintNumber,
    wheredidit: props.response.length > 0 ? props?.response[0]?.wheredidit : "",
    whydidoccur:
      props.response.length > 0 ? props?.response[0]?.whydidoccur : "",
    loggedinUserId: userDetails.userId,
    whereInYourManufacturingProcessDidTheRootCauseOccur:
      props.response.length > 0
        ? props?.response[0]
            ?.whereInYourManufacturingProcessDidTheRootCauseOccur
        : "",
  });

  const [errorTexts, setErrorTexts] = useState({
    HaveYouReproduced: "",
    Justification: "",
    manufacturingCause: "",
  });
  const defectValues = [
    {
      id: true,
      name: "Yes",
    },
    {
      id: false,
      name: "No",
    },
  ];
  //azure ad
  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  function validateWhy(value) {
    return !value
      ? { isValid: false, helperText: "*Required" }
      : { isValid: true, helperText: "" };
  }
  const columnsCause1 = [
    {
      title: "WHY (Root Cause)",
      field: "whyDidTheNonConformityOccur",
      editComponent: ({ value, onChange }) => (
        <TextField
          fullWidth
          onChange={(e) => onChange(e.target.value)}
          value={value}
          error={!value}
          helperText={!value ? "required" : ""}
          multiline
        />
      ),
      validate: (rowData) => validateWhy(rowData.whyDidTheNonConformityOccur),
    },
  ];
  const columnsCause2 = [
    {
      title: "WHY (Root Cause)",
      field: "whyWereYouNotAbleToDetectNonConformity",
      editComponent: ({ value, onChange }) => (
        <TextField
          fullWidth
          onChange={(e) => onChange(e.target.value)}
          error={!value}
          helperText={!value ? "required" : ""}
          value={value}
          multiline
        />
      ),
      validate: (rowData) =>
        validateWhy(rowData.whyWereYouNotAbleToDetectNonConformity),
    },
  ];
  var columnsAttachment = [
    {
      title: "Attachment",
      field: "fileName",
      editComponent: (props) => getAttachmentComponent(props),
    },
    {
      title: "Download",
      field: "download",
      editable: "never",
      render: (rowData) => DownloadFile(rowData),
    },
  ];
  function DownloadFile(data) {
    return (
      <Button
        className="pt-button--tertiary"
        variant="contained"
        onClick={() => downloadFileAttachment(data)}
      >
        Download
      </Button>
    );
  }
  function downloadFileAttachment(data) {
    let attachmentData = {
      fileName: data.fileName.trim(),
      fileUrl: data.fileUrl.trim(),
      filetype: data.filetype.trim(),
    };
    const fetchPromise = fetch(baseApiURL + "/Admin/downloadfile", {
      method: "post",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: "Bearer " + siteToken.token,
        AzureToken: azureToken.token,
        UserEmail: userDetails.userEmail,
        RoleName: userDetails.role,
        Gid: userDetails.gid,
        Roleid: userDetails.roleId,
        userId: UID.id,
      },
      body: JSON.stringify(attachmentData),
    });
    fetchPromise.then((response) => {
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download =
          "AttachmentD4_" +
          props.rowData[0]?.complaintNumber +
          attachmentData.filetype;
        link.click();
      });
    });
  }
  function handleRowDelete(oldFormData, resolve, reject) {
    var attachmentId = oldFormData.attachmentId;
    setIsLoader(true);
    DeleteDisciplineAttachments(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      attachmentId
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getAttchmentData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
        handleSnackOpen("Exception : " + error, "error");
        reject();
      });
  }
  const [uploadedFileName, setUploadedFileName] = useState("");
  const updateExcelHandler = (event) => {
    setSelectedFile(event.target.files);
    setUploadedFileName(event.target.files[0].name);
  };
  const handleChange = (event, value) => {
    let elem = event.target.name;
    switch (elem) {
      case "HaveYouReproduced":
        setInputValues({
          ...inputValues,
          [elem]: value.props.value,
        });
        setErrorTexts({
          ...errorTexts,
          HaveYouReproduced: "",
        });
        if (value.props.value === true) {
          setdisableJustify(true);
          setReproduce("Yes");
          inputValues.Justification = "";
        } else {
          setdisableJustify(false);
          setReproduce("No");
        }
        break;
      case "manufacturingCause":
        setInputValues({
          ...inputValues,
          whereInYourManufacturingProcessDidTheRootCauseOccur:
            event.target.value,
        });

        break;
      case "Justification":
        setInputValues({
          ...inputValues,
          [elem]: event.target.value,
        });

        setErrorTexts({
          ...errorTexts,
          Justification: "",
        });
        break;
      case "wheredidit":
        setInputValues({
          ...inputValues,
          wheredidit: event.target.value,
        });

        break;
      case "whydidoccur":
        setInputValues({
          ...inputValues,
          whydidoccur: event.target.value,
        });
        break;
      default:
        break;
    }
  };
  function getAttachmentComponent(objProps) {
    return (
      <form className="bulk-upload-form">
        {selectedFile == null ? (
          <>
            <TextField
              id="fileUploadAttachment"
              variant="filled"
              label="Attachment Upload"
              fullWidth
              onChange={updateExcelHandler}
              key={inputFileAttachment}
              type="file"
              InputLabelProps={{ shrink: true }}
              inputProps={{ multiple: true }}
              helperText={uploadedFileName}
            />
          </>
        ) : (
          <>
            <span>{uploadedFileName}</span>
          </>
        )}
      </form>
    );
  }

  function getTableDataCause1() {
    var complaintNum = props?.rowData[0].complaintNumber;
    setIsLoader(true);
    GetD4WhyDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      complaintNum
    )
      .then((response) => {
        setResponseLengthTable1(response);
        if (response.length > 1) {
          discpline4Data.discipline41 = true;
          dispatch(disciplineAction(discpline4Data));
        }
        setCause1TableData(response);
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  function getTableDataCause2() {
    var complaintNum = props?.rowData[0].complaintNumber;
    setIsLoader(true);
    GetD4WhyNotDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      complaintNum
    )
      .then((response) => {
        setResponseLengthTable2(response);
        if (response.length > 1) {
          discpline4Data.discipline42 = true;
          dispatch(disciplineAction(discpline4Data));
        }
        setCause2TableData(response);
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  const [d4Data, setD4Data] = useState({
    HaveYouReproduced:
      props.response.length > 0 ? props?.response[0].haveYouReproduced : null,
    Justification:
      props.response.length > 0 ? props?.response[0].justification : "",
    loggedinUserId: userDetails.userId,
    wheredidit: props.response.length > 0 ? props?.response[0]?.wheredidit : "",
    whydidoccur:
      props.response.length > 0 ? props?.response[0]?.whydidoccur : "",
    whereInYourManufacturingProcessDidTheRootCauseOccur:
      props.response.length > 0
        ? props?.response[0].whereInYourManufacturingProcessDidTheRootCauseOccur
        : "",
  });

  const handleRowAddCause1 = (newTableData, resolve, reject) => {
    setIsLoader(true);
    newTableData.loggedinUserId = userDetails.userId;
    newTableData.complaintNum = props?.rowData[0].complaintNumber;
    if (isEditable() === false) {
      handleSnackOpen("Action Restricted", "Info");
      reject();
      setIsLoader(false);
    } else {
      if (responseLengthTable1.length > 4) {
        reject();
        setIsLoader(false);
        handleSnackOpen("Maximum 5 WHY Analysis are Allowed", "info");
      } else {
        PostD4WhyDetails(
          siteToken.token,
          azureToken.token,
          UID.id,
          userDetails.userEmail,
          userDetails.gid,
          userDetails.role,
          userDetails.roleId,
          newTableData
        )
          .then((response) => {
            if (response.response) {
              handleSnackOpen(response.responseMsg, "success");
              resolve();
              setIsLoader(false);
              getTableDataCause1();
            } else {
              handleSnackOpen(response.responseMsg, "error");
              reject();
              setIsLoader(false);
            }
          })
          .catch((error) => {
            handleSnackOpen("Exception : " + error, "error");
            reject();
            setIsLoader(false);
          });
      }
    }
  };
  const handleRowAddCause2 = (newTableData, resolve, reject) => {
    setIsLoader(true);
    newTableData.loggedinUserId = userDetails.userId;
    newTableData.complaintNum = props?.rowData[0].complaintNumber;
    if (isEditable() === false) {
      handleSnackOpen("Action Restricted", "Info");
      reject();
      setIsLoader(false);
    } else {
      if (responseLengthTable2.length > 4) {
        reject();
        setIsLoader(false);
        handleSnackOpen("Maximum 5 WHY Analysis are Allowed", "info");
      } else {
        postD4WhyNotDetails(
          siteToken.token,
          azureToken.token,
          UID.id,
          userDetails.userEmail,
          userDetails.gid,
          userDetails.role,
          userDetails.roleId,
          newTableData
        )
          .then((response) => {
            if (response.response) {
              handleSnackOpen(response.responseMsg, "success");
              resolve();
              setIsLoader(false);
              getTableDataCause2();
            } else {
              handleSnackOpen(response.responseMsg, "error");
              reject();
              setIsLoader(false);
            }
          })
          .catch((error) => {
            handleSnackOpen("Exception : " + error, "error");
            reject();
            setIsLoader(false);
          });
      }
    }
  };
  function getAttchmentData() {
    setIsLoader(true);
    GetDisciplineAttachmentDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      props?.rowData[0].complaintNumber,
      props?.rootCaseData,
      "D4"
    )
      .then((response) => {
        setAttchmentData(response);
        setIsLoader(false);
      })
      .catch((error) => {
        handleSnackOpen("Error : " + error, "error");
        setIsLoader(false);
      });
  }

  function handleRowAddAttachment(newTableData, resolve, reject) {
    if (isEditable() === false) {
      handleSnackOpen("Action Restricted", "Info");
      reject();
      setIsLoader(false);
    } else if (!selectedFile) {
      handleSnackOpen("Please Select a File", "info");
      setIsLoader(false);
      reject();
    } else {
      setIsLoader(true);
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("file", selectedFile[i]);
      }
      formData.append("files", selectedFile);
      formData.append("userId", userDetails.userId);
      formData.append("ComplaintNumber", props?.rowData[0].complaintNumber);
      formData.append("Discipline", "D4");
      setIsLoader(false);
      AddDisciplineAttachmentDetails(
        siteToken.token,
        azureToken.token,
        UID.id,
        userDetails.userEmail,
        userDetails.gid,
        userDetails.role,
        userDetails.roleId,
        formData
      )
        .then((response) => {
          if (response.response) {
            handleSnackOpen(response.responseMsg, "success");
            setUploadedFileName("");
            resolve();
            setIsLoader(false);
            getAttchmentData();
            setSelectedFile(null);
          } else {
            handleSnackOpen(response.responseMsg, "error");
            reject();
            setIsLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoader(false);
          setSelectedFile(null);
          setInputFileAttachment(Date.now);
          handleSnackOpen("Exception : " + error, "error");
          reject();
        });
    }
  }

  const handleRowUpdateCause1 = (
    newTableData,
    oldTableData,
    resolve,
    reject
  ) => {
    newTableData.loggedinUserId = userDetails.userId;

    setIsLoader(true);
    newTableData.loggedinUserId = userDetails.userId;
    newTableData.complaintNum = props?.rowData[0].complaintNumber;
    UpdateD4_Why(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      newTableData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getTableDataCause1();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        reject();
        setIsLoader(false);
      });
  };
  function isEditable() {
    if (userDetails.roleId !== 3 || props.rowData[0]?.status === "Approved") {
      return false;
    } else {
      if (
        props.rowData[0]?.status === "Pending by Supplier" ||
        props.rowData[0]?.status === "Rejected by User"
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  const handleRowUpdateCause2 = (
    newTableData,
    oldTableData,
    resolve,
    reject
  ) => {
    newTableData.loggedinUserId = userDetails.userId;
    setIsLoader(true);
    newTableData.loggedinUserId = userDetails.userId;
    newTableData.complaintNum = props?.rowData[0].complaintNumber;
    UpdateD4_WhyNot(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      newTableData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getTableDataCause2();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        reject();
        setIsLoader(false);
      });
  };
  function handleRowDeleteWhy(oldFormData, resolve, reject) {
    setIsLoader(true);
    DeleteD4WhyDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      oldFormData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getTableDataCause1();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
        handleSnackOpen("Exception : " + error, "error");
        reject();
      });
  }
  function handleRowDeleteWhyNot(oldFormData, resolve, reject) {
    setIsLoader(true);
    DeleteD4WhyNotDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      oldFormData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          resolve();
          setIsLoader(false);
          getTableDataCause2();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          reject();
          setIsLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
        handleSnackOpen("Exception : " + error, "error");
        reject();
      });
  }
  let reproduced =
    inputValues.HaveYouReproduced === false ||
    inputValues.HaveYouReproduced === true
      ? true
      : false;

  useEffect(() => {
    if (props?.response[0]?.justification) {
      setdisableJustify(false);
    }
    props.getD4Details(props.rootCaseData);
    getTableDataCause1();
    getTableDataCause2();
    getAttchmentData();
    getRootCauseAnaysisDropdown();
  }, []);
  const [rootCaseData, setRootCaseData] = useState(1);
  const handleRootCauseAnalysis = (e) => {
    setRootCaseData(e.target.value);
  };

  const [rootCauseDropdown, setRootCauseDropdown] = useState([]);
  function getRootCauseAnaysisDropdown() {
    console.log("nidhi called");
    getRCADDL(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId
    )
      .then((response) => {
        console.log("nidhi res", response);
        setRootCauseDropdown(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <Grid container spacing={2} md={12}>
      <Grid item xs={12} className="details-center">
        <h3 className="title-heading">Root Cause Analysis</h3>
        <FormControl
          style={{
            display: "flex",
            width: "300px",
            marginLeft: "20px",
            alignItems: "flex-start",
            justifyContent: "flex-end",
          }}
        >
          <InputLabel
            shrink
            htmlFor="bootstrap-input"
            style={{
              fontWeight: "bold",
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            No of root cause:
          </InputLabel>
          <Select
            labelId="rootcauseId"
            id="rootcauseId"
            name="rootcauseId"
            onChange={handleRootCauseAnalysis}
            value={rootCaseData}
            input={<BootstrapInput />}
            style={{ flexGrow: 1 }}
          >
            {rootCauseDropdown.map((item) => (
              <MenuItem key={item.rcaid} value={item.rcaid}>
                {item.rca}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={12}>
        {rootCaseData === 1 && <Page1 {...props} rootCaseData={rootCaseData} />}
        {rootCaseData === 2 && <Page2 {...props} rootCaseData={rootCaseData} />}
        {rootCaseData === 3 && <Page3 {...props} rootCaseData={rootCaseData} />}
        {rootCaseData === 4 && <Page4 {...props} rootCaseData={rootCaseData} />}
        {rootCaseData === 5 && <Page5 {...props} rootCaseData={rootCaseData} />}
      </Grid>
    </Grid>
  );
}
